<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <v-overlay :value="dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
        </v-row>

        <v-card
    class="mx-auto mt-6"
    width="1000"
  >
      <v-progress-linear
        :active="loading"
        :indeterminate="loading"
        absolute
        height="50"
        color="deep-purple accent-4"
      ></v-progress-linear>

      <v-col
  v-if="loading"
          class="text-title text-center"
          cols="12"
        >
        <h5 class="purple--text pa-2 font-weight-bold">
          กรุณารอในหน้านี้ จนกว่าระบบจะรันข้อมูล สำเร็จ
                  </h5>
        </v-col>

<v-stepper v-model="step">
    <v-stepper-header>
      <v-stepper-step step="1" :complete="steps[1].status" :rules="steps[1].rule">Cleaning</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="2" :complete="steps[2].status" :rules="steps[2].rule">Check In/Out</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="3" :complete="steps[3].status" :rules="steps[3].rule">Deligent/Absent</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="4" :complete="steps[4].status" :rules="steps[4].rule">Leave</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="5" :complete="steps[5].status" :rules="steps[5].rule">Point</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="6" :complete="steps[6].status" :rules="steps[6].rule">OT</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="7" :complete="steps[7].status" :rules="steps[7].rule">Adjust</v-stepper-step>

      <!-- <v-stepper-step
        :rules="[() => false]"
        step="5"
      >
        Custom channels
        <small>Alert message</small>
      </v-stepper-step> -->

    </v-stepper-header>
  </v-stepper>

    <v-container style="height: 282px;">
      <v-row
        class="fill-height"
        align="center"
        justify="center"
      >
        <v-scale-transition>
          <div
            v-if="!loading"
            class="text-center"
          >
            <v-btn
              color="green darken-1"
              dark
              @click="getData()"
            >
              Start Run
            </v-btn>
          </div>
        </v-scale-transition>
      </v-row>
    </v-container>
  </v-card>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
import moment from 'moment'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  data () {
    return {
      PK: '',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'อัพเดทข้อมูล',
          disabled: true,
          href: '/System/ReportRun'
        }
      ],
      // End Menu Config
      dataReady: false,
      loading: false,
      year: '',
      month: '',
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      dataItem: [],
      session: this.$session.getAll(),
      step: 0,
      steps: [
        {status: false, rule: [() => true]},
        {status: false, rule: [() => true]},
        {status: false, rule: [() => true]},
        {status: false, rule: [() => true]},
        {status: false, rule: [() => true]},
        {status: false, rule: [() => true]},
        {status: false, rule: [() => true]},
        {status: false, rule: [() => true]}
      ]
    }
  },
  async mounted () {
    this.month = this.getMonthTh()
    this.year = moment().format('YYYY')
    // await this.getData()
  },
  methods: {
    async getData () {
      this.dataReady = true
      this.loading = true
      await this.runJob(1)
      await this.runJob(2)
      await this.runJob(3)
      await this.runJob(4)
      await this.runJob(5)
      await this.runJob(6)
      await this.runJob(7)
    },
    async runJob (step) {
      this.step = step
      var month = this.getMonthThToINT(this.month)
      var year = this.year
      await axios
        .get(`${this.DNS_IP}/report/conjob/runByMonthYear/Step${step}/${month}/${year}`)
        .then(async (response) => {
          this.steps[step].status = true
          console.log('response', response)
          if (step === 7) {
            this.dataReady = false
            this.loading = false
          }
        }).catch((error) => {
          this.steps[step].rule = [() => false]
          console.log(error)
          this.dataReady = false
          this.loading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/System/ReportRun.vue